import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.image-video-tile--video',
        video: '.video-js',
        playPauseBtn: '.image-video-tile__play-pause-btn',
        playPauseBtnIcon: '.image-video-tile__play-pause-btn-icon',
        videoWrapper: '.image-video-tile__video-wrapper',
        imageWrapper: '.image-video-tile__image-wrapper',
    },
    classNames: {
        playIcon: 'image-video-tile__play-pause-btn-icon--play',
        pauseIcon: 'image-video-tile__play-pause-btn-icon--pause',
    },
    dataAttributes: {
        autoplay: 'autoplay',
    },
    pauseIconCircle: '<img src="assets/icons/pauseCircle.svg" width="24px" height="24px" alt="Play / Pause">',
    pauseIconCircleWhite: '<img src="assets/icons/pauseCircleWhite.svg" width="24px" height="24px" alt="Play / Pause">',
    playIconPaths: '<span class="path1"></span><span class="path2"></span>',
};

class ImageVideoTile {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
    }

    init() {
        // listen for initialization event
        this._elements = this._getDomElements();
        this._addEventListeners();
        this._screenClick();

        // video isnt allowed by localization
        // show fallback image & hide play pause button 
        if(this._elements.$video.length === 0) {
            this._elements.$playPauseBtn.hide();
            return;
        }


        this._elements.$playPauseBtnIcon.addClass(config.classNames.playIcon);
        this._autoPlayVideo();
    }

    _getDomElements() {
        return {
            $video: this._$rootElement.find(config.selectors.video),
            $playPauseBtn: this._$rootElement.find(config.selectors.playPauseBtn),
            $playPauseBtnIcon: this._$rootElement.find(config.selectors.playPauseBtnIcon),
            $videoWrapper: this._$rootElement.find(config.selectors.videoWrapper),
            $imageWrapper: this._$rootElement.find(config.selectors.imageWrapper),
        };
    }

    _addEventListeners() {
        this._elements.$playPauseBtn.on('click', () => {
            this._playPauseHandler();
        });
    }

    // eslint-disable-next-line class-methods-use-this
    _autoPlayVideo() {
        if (this._elements.$video.data(config.dataAttributes.autoplay)) {
            this._muteVideo();
            this._playPauseHandler();
        }
    }

    _muteVideo() {
        const videoSettings = this._elements.$video[0];
        videoSettings.player.muted(true);
    }

    _playPauseHandler() {
        const videoSettings = this._elements.$video[0];

        if (videoSettings.player.paused()) {
            videoSettings.player.play();

            this._elements.$playPauseBtnIcon.removeClass(config.classNames.playIcon);
            this._elements.$playPauseBtnIcon.addClass(config.classNames.pauseIcon);
        } else {
            videoSettings.player.pause();
            this._elements.$playPauseBtnIcon.addClass(config.classNames.playIcon);
            this._elements.$playPauseBtnIcon.removeClass(config.classNames.pauseIcon);
            // this._elements.$playPauseBtnIcon.addClass(config.classNames.playIcon);
            // this._elements.$playPauseBtnIcon.html(config.playIconPaths);
        }
    }

    _screenClick() {
        const _this = this;
        const videoSettings = this._elements.$video[0];

        
        if(videoSettings && videoSettings.player) {
            videoSettings.player.on('play', function() {
                _this._elements.$imageWrapper.hide();
                _this._elements.$videoWrapper.show();
            });
    
            this._elements.$video.on('click', (e) => {
                e.preventDefault();

                if (videoSettings.player.paused()) {
                    this._elements.$imageWrapper.hide();
                    this._elements.$videoWrapper.show();
                    videoSettings.player.play();
                    // this._elements.$playPauseBtnIcon.empty();
                    // this._elements.$playPauseBtnIcon.html(config.playIconPaths);
                    this._elements.$playPauseBtnIcon.removeClass(config.classNames.playIcon);
                    this._elements.$playPauseBtnIcon.addClass(config.classNames.pauseIcon);
                } else {
                    videoSettings.player.pause();
                    this._elements.$playPauseBtnIcon.addClass(config.classNames.playIcon);
                    this._elements.$playPauseBtnIcon.removeClass(config.classNames.pauseIcon);
                }
            });
        }

    }
}

moduleRegistry.registerModule('ImageVideoTile', ImageVideoTile);
moduleRegistry.autoApplyModule('ImageVideoTile', config.selectors.root);